// Single source of truth for the Favorites Designer season dropdowns
// (Layout tab's season selector AND the Look editor's look/photo season
// pickers). Previously each component kept its own copy of this list, which
// drifted out of sync with the pipeline — grad2026 was a fully-supported
// season in LookTemplate::SPEC_PREFIX (app/models/look_template.rb) yet never
// appeared in the dropdown because the JS copies were never updated.
//
// INVARIANT: every `value` here MUST have a matching key in
// LookTemplate::SPEC_PREFIX, or looks authored for it compute no spec_id and
// never reach EC2. The guard spec spec/models/favorites_seasons_sync_spec.rb
// parses this file and enforces that against the Ruby map — keep both in sync.
//
// fall2027 split (#4520): HS/MS looks are authored under fall2027_hs_ms (spec
// ids U2027-*), elementary under fall2027_elem (E2027-*). The unified fall2027
// (FALL27-*) is retired — kept selectable only so existing looks can be
// viewed/migrated; labeled "do not use" so a designer can't pick it unknowingly.
export const FAVORITES_SEASONS = [
  { value: 'spring2026', label: 'spring2026' },
  { value: 'fall2026', label: 'fall2026' },
  { value: 'grad2026', label: 'grad2026' },
  { value: 'spring2027', label: 'spring2027' },
  { value: 'fall2027_hs_ms', label: 'fall2027 HS/MS (U2027)' },
  { value: 'fall2027_elem', label: 'fall2027 Elementary (E2027)' },
  { value: 'fall2027', label: 'fall2027 (legacy — do not use)' },
  // seniors2027's production specs (SEN27) are the hand-maintained CSV on S3
  // that predates the Favorites Designer — it is NOT in DESIGNER_OWNED_EXPORTS,
  // so authoring/publishing looks here has NO effect on those specs (nothing
  // exports seniors2027 DB rows to the CSV EC2 renders from). Selectable only
  // so designers can build/preview senior looks in the DB.
  { value: 'seniors2027', label: 'seniors2027' },
  { value: 'sports', label: 'sports' },
];

export const FAVORITES_SEASON_VALUES = FAVORITES_SEASONS.map((s) => s.value);

// The Look editor's per-look / per-collage-photo season pickers allow an
// explicit "no season chosen" state; the Layout tab always targets a real one.
export const FAVORITES_SEASONS_WITH_NONE = [
  { value: '', label: '(none)' },
  ...FAVORITES_SEASONS,
];
